import { render, staticRenderFns } from "./renewPrice.vue?vue&type=template&id=30186a10&scoped=true&"
import script from "./renewPrice.vue?vue&type=script&lang=js&"
export * from "./renewPrice.vue?vue&type=script&lang=js&"
import style0 from "./renewPrice.vue?vue&type=style&index=0&id=30186a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30186a10",
  null
  
)

export default component.exports